import { Container } from "pixi.js";
import type { GameTransitionPort } from "@slot/game-shell";

/**
 * `ModalLayer/GameModalContainer/GameTransitionView` — the base ⇄ feature transition overlay. This
 * game has nothing to play (empty `prefabHost` in the scene), so the
 * transition resolves immediately; the shell presenter still shows/hides the root and fires the cue.
 */
export class GameTransitionView extends Container implements GameTransitionPort {
  public constructor() {
    super({ label: "GameTransitionPanel" });
    this.visible = false;
  }

  public show(): void {
    this.visible = true;
  }

  public hide(): void {
    this.visible = false;
  }

  public playTransition(): Promise<void> {
    return Promise.resolve();
  }
}
